// Dependencias generales
import React from "react";

// Función del router
const InitialConfigHeader = (params) => {
  
  return (    
    <div id="stepIntroBubble" className="description bubble">        
      <h1 className="headline-03">{params.Title}</h1>
      <div id="textoIntro" className="step description">{params.Intro}</div>
    </div>    
  )
}

export default InitialConfigHeader